import Feature from "@insightfulscience/atomic-react/Feature";
import FeatureImage from "@insightfulscience/atomic-react/Feature/Image";
import FeatureMeta from "@insightfulscience/atomic-react/Feature/Meta";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import Html from "@insightfulscience/smart-react/Html";
import React from "react";
import { useLocale } from "@insightfulscience/smart-react/i18";

const tabImg4 = "/images/geneious/homepage/integrated-platform.png";

export default () => {
	const [t] = useLocale("home-page");

	return (
		<Feature top className="mt-10">
			<FeatureMeta md={5}>
				<FeatureMeta.Title>{t("ADVANTAGES_CONTENT_4_TITLE")}</FeatureMeta.Title>
				<FeatureMeta.Description>
					<Paragraph sx={{ fontSize: "l" }}>
						<Html Tag="span">{t("ADVANTAGES_CONTENT_4_DESCRIPTION")}</Html>
					</Paragraph>
				</FeatureMeta.Description>
			</FeatureMeta>
			<FeatureImage md={7} shadow src={tabImg4} />
		</Feature>
	);
};
